import React, { useEffect, useState } from 'react';
import axios from 'axios';
import ReactJson from 'react-json-view';
import Skeleton from './common/Skeleton';

const SbomView = ({ sbomLink }) => {
  const [sbomData, setSbomData] = useState(null);

  useEffect(() => {
    const fetchSbomData = async () => {
      try {
        const response = await axios.get(sbomLink);
        setSbomData(response.data);
      } catch (error) {
        console.error('Failed to fetch SBOM data:', error);
      }
    };

    fetchSbomData();
  }, [sbomLink]);

  return (
    <div>
      {sbomData ? (
        <ReactJson src={sbomData} theme="monokai" />
      ) : (
        <div style={{ padding: '0.5rem 0' }}>
          <Skeleton.Text lines={4} lastWidth="60%" />
        </div>
      )}
    </div>
  );
};

export default SbomView;
